
import { useDispatch, useSelector } from "react-redux";
import { setHighlightedOrderAssign } from "../../../../store/UnifiedControlPlaneSlice";
import { ucp_visualization_presentation } from "../CesiumUtils/Visualizations";
import { getStatusDetails } from "../Schedule/CurrentScheduleView";
import { getTimeEpochToUTC } from "../Utils/HelperFunctions";
import CustomToolTip from "../../../CommonComponents/CustomToolTip";
import { useEffect } from "react";

const SingleOrderDetails = ({ orderAssignments, ucpViewer }) => {
  const dispatch = useDispatch();
  const highlightedOrderAssign = useSelector(
    (state) => state.unifiedControlPlane.highlightedOrderAssign
  );

  useEffect(() => {
    const onOutSideClick = (event) => {
      if (!ucpViewer || event.target.closest(".subOrderTypeMainBars")) return;
      ucp_visualization_presentation().remove_highlight_strip(
        ucpViewer,
        "Highlight_Order_Assignment",
      );
    }
    document.addEventListener("click", onOutSideClick);
    return () => {
      document.removeEventListener("click", onOutSideClick);
    }
  }, [ucpViewer])

  const setOrderAssignmentActive = (item) => {
    // COMPLETED ==> green highlighted & NOT-COMPLETED ==> white highlighted
    const whiteHighilightRgba = [255, 255, 255, 255];
    const greenHighlightRbga = [204, 245, 78, 255];
    dispatch(setHighlightedOrderAssign(item));
    const highlightColor =
      item.state === "CaptureComplete" || item.state === "DownlinkComplete"
        ? greenHighlightRbga
        : whiteHighilightRgba;
    if (item?.type === "Order") {
      ucp_visualization_presentation().highlight_strip(
        ucpViewer,
        item?.data,
        "Highlight_Order_Assignment",
        highlightColor
      );
    } else {
      ucp_visualization_presentation().remove_highlight_strip(
        ucpViewer,
        "Highlight_Order_Assignment",
      );
    }
  };

  return orderAssignments.map((item, index) => (
    <div key={index}>
      <div
        className="subOrderTypeMainBars"
        onClick={() => setOrderAssignmentActive(item)}
      >
        <div
          className={
            `
            d-flex align-items-center gap-1 subOrdersTypeHeaderBar
             ${item?.type !== "Order" && 'cursor-auto'}
            ${item?.assignmentId === highlightedOrderAssign?.assignmentId
              ? "activeHeaderBarSubOrders noTopPadding "
              : "blackHeaderBarSubOrders noTopPadding"}`

          }
        >
          <CustomToolTip title={getStatusDetails(item?.state, "Text")}>
            <button className={`orderProgressDivPendingBtn statusButton ${item?.state === "active" ? "rotate-icon" : ""}`}>
              {getStatusDetails(item?.state, "Icon")}
            </button>
          </CustomToolTip>
          <div className="bandIcon">
            {item?.data?.band === "Imager" ? (
              <img
                src={require("../../assets/raw/DbIcon.svg").default}
                alt=""
                className="opacity-75"
                height={"16px"}
                width={"16px"}
              />
            ) : (
              <img
                src={require("../../assets/raw/SatelliteTabs.svg").default}
                alt=""
                height={"20px"}
                width={"20px"}
              />
            )}
          </div>
          <div className="orderTitleMainDiv flex-1 justify-content-between">
            <div className="orderTitleDiv">
              <div className="subOrderTitleName grey">
                {item?.data?.satellite?.name}&ensp;
              </div>
              <div className="subOrderTitleName yellow">
                {item?.type === "Order" ? item?.data?.type : item?.label}
              </div>
            </div>
            <div className="orderTitleDiv">
              {/* <div className="subOrderTitleName grey">{item?.data?.band ? item?.data?.band : item?.data?.ground_station?.name}&ensp;</div> */}
              <div className="subOrderTitleName grey">
                {getTimeEpochToUTC(item?.startEpochSec)}
              </div>
            </div>
          </div>
          {/* <button className="orderProgressDivPendingBtn" style={{ position: "relative", top: "-16px" }}>
            <img className="pauseIcon" src={require("../assets/raw/OpenNewWindowIcon.svg").default} alt=""/>
          </button> */}
        </div>

      </div>
    </div>
  ));
};

export default SingleOrderDetails;
